<template>
  <div>
    <headers />
    <div class="information containers">
      <h3>热门资讯</h3>
      <ul class="clearfix">
        <router-link
          tag="li"
          :to="{path:'/infordetails',query:{id:item.id}}"
          v-for="(item) in inarr"
          :key="item.id"
          :data-id="item.id"
        >
          <div class="pic">
            <img :src="item.imgUrl" alt />
          </div>
          <h4>{{item.title}}</h4>
          <p>{{item.info}}</p>
        </router-link>
      </ul>
      <div class="pageing">
        <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
        <el-pagination
          small
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :background="true"
          :total="pingjia.total_pages==null?1:pingjia.total_pages"
          :page-size="10"
          @current-change="currentchange"
          :current-page="page"
        ></el-pagination>
        <span @click="pageend" class="spansx" :class="[page == pingjia.total_pages?'on':'']">尾页</span>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { Pagination } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    headers,
    footers,
    [Pagination.name]: Pagination
  },
  data() {
    return {
      inforlist: [],
      page: 1,
      total_pages: 0,
      inarr:[],
      pingjia:{},
    };
  },
  methods: {
      //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.total_pages;
    },
    informationfunc() {
      this.$axios({
        method: "post",
        url: `/index/article.getList`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
          this.pingjia = totaldata;
          this.inarr = totaldata.arr;
          this.count = totaldata.total_pages;
        }
      });
    }
  },
  mounted() {
    this.informationfunc();
  }
};
</script>

<style scoped>
@import "~@/assets/css/common.css";
.information h3 {
  text-align: center;
  font-size: 40px;
  color: #5b5b5b;
  margin-top: 70px;
  margin-bottom: 60px;
  font-weight: bold;
}

.information li {
  width: 31%;
  margin-right: 3.4%;
  float: left;
  margin-bottom: 55px;
  cursor: pointer;
}

.information li .pic {
  height: 154px;
  overflow: hidden;
}

.information li .pic img{
  min-height: 100%;
}

.information li:nth-of-type(3n) {
  margin-right: 0;
}

.information li h4 {
  font-size: 18px;
  color: #232b36;
  margin-top: 25px;
  margin-bottom: 18px;
  text-align: left;
  font-weight: bold;
}

.information li p {
  font-size: 14px;
  color: #999999;
  line-height: 1.5em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: left;
}
</style>